'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _swiperEsm = require('swiper/js/swiper.esm.js');

var _utils = require('../utils');

var _helpers = require('./_helpers');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var swiperContainer = context.getElement('.' + context.className + '_Carousel');

  var carousel = void 0;
  var currentSizing = void 0;

  makeCarousel();

  window.addEventListener('resize', makeCarousel);

  function makeCarousel() {
    if (currentSizing !== 'desktop' && window.innerWidth >= _utils.mediaBreakpoints.sm && carousel !== undefined) {
      carousel.destroy();
      carousel = undefined;
    } else if (currentSizing !== 'mobile' && window.innerWidth < _utils.mediaBreakpoints.sm && carousel !== undefined) {
      carousel.destroy();
      carousel = undefined;
    }

    if (window.innerWidth >= _utils.mediaBreakpoints.sm) {
      currentSizing = 'desktop';
    } else {
      currentSizing = 'mobile';
      carousel = (0, _helpers.initialiseSwiper)(swiperContainer, {
        loop: true,
        watchSlidesProgress: true,
        slidesPerView: 1,
        centeredSlides: true,
        initialSlide: 0,
        spaceBetween: 0,
        speed: 500,
        slideClass: context.className + '_Slide',
        autoplay: {
          delay: 3000
        }
      }, [_swiperEsm.Autoplay]);
    }
  }
}